<template>
  <div class="footer">
    <div class="box-wrap">
      <div class="box">
        <p>联系我们</p>
        <p>CONTACT US</p>
      </div>
      <div class="box">
        <p>新华网循证医保鉴证核查平台-客服中心</p>
        <p>电话：025-83650181</p>
        <p>传真：025-84436525</p>
        <p>咨询：QQ- 813881360</p>
      </div>
      <div class="box">
        <p>新华网循证医保鉴证核查平台-业务咨询</p>
        <p>电话：010-88050623</p>
        <p>邮箱：xhyb.kf@xinhuanet.com</p>
      </div>
    </div>
    <div class="footer-text">
      <p>联系地址： 北京市宣武门西大街129号金隅大厦 联系电话：010-88050623</p>
      <p>CopyRight © {{new Date().getFullYear()}} xinhuanet.com All Rights Reserved 版权所有 新华网股份有限公司</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "g-footer"
};
</script>
<style lang="stylus" scoped>
.footer {
  background-color: #171717;

  .box-wrap {
    width: 1190px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 0;
    padding: 65px 0 88px;

    .box {
      display: inline-block;
      vertical-align: top;

      &:nth-child(1) {
        p {
          &:nth-child(1) {
            font-size: 36px;
            line-height: 1;
          }

          &:nth-child(2) {
            margin-top: 15px;
            font-family: SegoeUIEmoji;
            font-size: 22px;
          }
        }
      }

      &:nth-child(2) {
        position: relative;
        margin-left: 238px;

        &::after {
          content: '';
          position: absolute;
          height: 100px;
          top: 0;
          width: 0;
          border-right: 1px solid #ffffff;
          right: -85px;
        }
      }
      &:nth-child(3) {
        margin-left 174px
      }

      &:nth-child(2), &:nth-child(3) {
        
        font-size: 14px;

        p {
          line-height: 1;
          margin-top: 15px;

          &:nth-child(1) {
            font-size: 18px;
            margin-top: 0;
          }
        }
      }
    }
  }
  .footer-text {
    color #ffffff
    background-color #0d0d0d;
    height 60px
    text-align center
    p {

      &:nth-child(1) {
        padding-top 10px
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/g-footer/index.vue